import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../../tracking/types/AmplitudeAuthPlacement";
import {ConsistentRegisterForm} from "./ConsistentRegisterForm";
import {SocialAuth} from "./SocialAuth";

interface IProps {
    userSource: UserSource;
    gtmSourceSection?: string;
    socialAuthSuccess: () => void;
    emailAuthSuccess: () => void;
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export const SemanticSearchSignupForm = (props: IProps) => {
    const {userSource, gtmSourceSection, socialAuthSuccess, emailAuthSuccess, amplitudePlacement} = props;

    return (
        <>
            <SocialAuth
                onAuthSuccess={socialAuthSuccess}
                userSource={userSource}
                gtmSourceSection={gtmSourceSection}
                amplitudePlacement={amplitudePlacement}
                authContext="registration"
            />

            <Text align="center" className={separatorTextStyle} variant="info_txt_1">
                Lub zarejestruj się
            </Text>

            <ConsistentRegisterForm
                onAuthSuccess={emailAuthSuccess}
                userSource={userSource}
                gtmSourceSection={gtmSourceSection}
                amplitudePlacement={amplitudePlacement}
            />
        </>
    );
};

const separatorTextStyle = css({
    pt: 1.5,
    textAlign: "center"
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../../tracking/types/AmplitudeAuthPlacement";
import {ConsistentRegisterForm} from "./ConsistentRegisterForm";
import {SocialAuth} from "./SocialAuth";

interface IProps {
    userSource: UserSource;
    gtmSourceSection?: string;
    socialAuthSuccess: () => void;
    emailAuthSuccess: () => void;
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export const SemanticSearchSignupForm = (props: IProps) => {
    const {userSource, gtmSourceSection, socialAuthSuccess, emailAuthSuccess, amplitudePlacement} = props;

    return (
        <>
            <SocialAuth
                onAuthSuccess={socialAuthSuccess}
                userSource={userSource}
                gtmSourceSection={gtmSourceSection}
                amplitudePlacement={amplitudePlacement}
                authContext="registration"
            />

            <Text align="center" className={separatorTextStyle} variant="info_txt_1">
                Lub zarejestruj się
            </Text>

            <ConsistentRegisterForm
                onAuthSuccess={emailAuthSuccess}
                userSource={userSource}
                gtmSourceSection={gtmSourceSection}
                amplitudePlacement={amplitudePlacement}
            />
        </>
    );
};

const separatorTextStyle = css({
    pt: 1.5,
    textAlign: "center"
});
